import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Box,
    Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const PDFPreviewModal = ({ isOpen, onClose, pdfFilePath, title }) => {
    const { t } = useTranslation();

    const downloadPDF = () => {
        const link = document.createElement("a");
        link.href = pdfFilePath;
        link.download = title;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl" closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent
                maxWidth="90%"
                marginLeft="2%"
                overflow="hidden"
                style={{ top: '5%', left: '2.5%' }}
            >
                <ModalHeader textColor={"#0B4E5A"}>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody maxHeight="69vh">
                    <Box width="100%" height="69vh" borderRadius="lg">
                        <iframe
                            src={pdfFilePath}
                            width="100%"
                            height="100%"
                            title={title}
                            frameBorder="0"
                            style={{
                                borderRadius: '0.5rem',  // Matches Chakra UI's 'lg' border radius
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                            }}
                        >
                            {t('infoPage.pdfPreviewNotSupported')}
                        </iframe>
                    </Box>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default PDFPreviewModal;